module.exports = __webpack_public_path__ + "img/gno.ecb6c65d.svg";